import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export function useReviewCount() {
  const [count, setCount] = useState(0);
  const prev = useRef(null);
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    const check = () => api.get("/pos/review-count").then(({ data }) => {
      if (!alive) return;
      if (prev.current !== null && data.count > prev.current) {
        const n = data.count - prev.current;
        toast.info(`${n} new PO${n === 1 ? "" : "s"} arrived through the WhatsApp link`, { id: "review-new" });
        window.dispatchEvent(new Event("review:new"));
      }
      prev.current = data.count;
      setCount(data.count);
    }).catch(() => {});
    check();
    const t = setInterval(check, 30000);
    window.addEventListener("review:changed", check);
    return () => { alive = false; clearInterval(t); window.removeEventListener("review:changed", check); };
  }, [location.pathname]);

  return count;
}
